// src\themes\default\elements\Header\HeaderContainer.tsx

'use client';

import { ReactNode, useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { cn } from '@/core/lib/utils';

const SCROLL_THRESHOLD = 40;

type HeaderContainerProps = {
    children: ReactNode;
};

export default function HeaderContainer({ children }: HeaderContainerProps) {
    const [scrolled, setScrolled] = useState(false);
    const pathname = usePathname();

    // تشخیص صفحه‌ی اصلی (با در نظر گرفتن پیشوند زبان مثل /fa یا /en)
    const isHome = /^\/[a-z]{2}\/?$/.test(pathname) || pathname === '/';

    useEffect(() => {
        if (!isHome) return; // تو صفحات دیگه نیازی به گوش‌دادن به اسکرول نیست
        const handleScroll = () => setScrolled(window.scrollY > SCROLL_THRESHOLD);
        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [isHome]);

    // تو صفحات غیر از هوم، هدر همیشه در وضعیت "scrolled" (solid) حساب می‌شه
    const effectiveScrolled = isHome ? scrolled : true;

    return (
        <header
            data-scrolled={effectiveScrolled}
            className={cn(
                'group/header fixed top-0 inset-x-0 z-50 h-18 print:hidden flex items-center justify-between px-4 py-4 sm:px-6 lg:px-12',
                'transition-colors duration-300',
                effectiveScrolled
                    ? 'bg-primary-0/70 backdrop-blur-md text-primary-900 shadow-sm'
                    : 'bg-transparent text-primary-0'
            )}
        >
            {isHome && (
                <div
                    aria-hidden
                    className={cn(
                        'pointer-events-none absolute top-0 inset-x-0 h-64 -z-10 bg-gradient-to-b from-black/55 via-black/25 to-transparent',
                        'transition-opacity duration-300',
                        scrolled ? 'opacity-0' : 'opacity-100'
                    )}
                />
            )}
            {children}
        </header>
    );
}